import { render } from "./GastouderMutationOverview.vue?vue&type=template&id=88fd930c&scoped=true"
import script from "./GastouderMutationOverview.vue?vue&type=script&lang=js"
export * from "./GastouderMutationOverview.vue?vue&type=script&lang=js"

import "./GastouderMutationOverview.vue?vue&type=style&index=0&id=88fd930c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88fd930c"]])

export default __exports__